export const isRouteChunkLoadError = (error) => {
  const name = String(error?.name || '');
  const message = String(error?.message || '');

  return (
    name === 'ChunkLoadError' ||
    /Loading chunk \d+ failed/i.test(message) ||
    /CSS_CHUNK_LOAD_FAILED/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message)
  );
};
